import { MapTo } from '@adobe/aem-react-editable-components';
import SectionList, { SectionListIsEmptyFn, SectionListProperties } from './SectionList';

const RESOURCE_TYPE = 'learning-academy/components/custom/sectionlist';

export default MapTo<SectionListProperties>(RESOURCE_TYPE)(SectionList, { isEmpty: SectionListIsEmptyFn });
